var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    fill: "#FEFEFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    stroke: "#64696C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 8.5C13.6193 8.5 12.5 9.61929 12.5 11C12.5 12.3807 13.6193 13.5 15 13.5C16.3807 13.5 17.5 12.3807 17.5 11C17.5 9.61929 16.3807 8.5 15 8.5ZM11.5 11C11.5 9.067 13.067 7.5 15 7.5C16.933 7.5 18.5 9.067 18.5 11C18.5 12.933 16.933 14.5 15 14.5C13.067 14.5 11.5 12.933 11.5 11Z",
    fill: "#171717"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 16.5C11.9624 16.5 9.5 18.9624 9.5 22C9.5 22.2761 9.27614 22.5 9 22.5C8.72386 22.5 8.5 22.2761 8.5 22C8.5 18.4101 11.4101 15.5 15 15.5C18.5899 15.5 21.5 18.4101 21.5 22C21.5 22.2761 21.2761 22.5 21 22.5C20.7239 22.5 20.5 22.2761 20.5 22C20.5 18.9624 18.0376 16.5 15 16.5Z",
    fill: "#171717"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.3982fb5c84c2901c67de7bb3f4dd1760.svg";
export { ForwardRef as ReactComponent };